import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { defineMessages, injectIntl } from 'react-intl';

import ListDataPod from '../../../components/ListDataPod';

const messages = defineMessages({
  title: {
    id: 'hubs.student-life.nearest-city.title',
    defaultMessage: 'Nearest City',
  },
  distanceMessage: {
    id: 'hubs.student-life.nearest-city.distance-from-campus',
    defaultMessage: 'miles from campus',
  },
});

const NearestCity = ({ nearestCity, intl }) => {
  const city = get(nearestCity, 'city.value', '');
  const distance = get(nearestCity, 'distance.value', '');
  let subText = '';

  if (distance) {
    subText = `${distance} ${intl.formatMessage(messages.distanceMessage)}`;
  }
  const title = intl.formatMessage(messages.title);

  return city ? (
    <ListDataPod
      header={title}
      ariaLabel={`${title}, ${city}`}
      content={{
        list: [],
        subText,
        value: city,
        boldLastItem: !!distance,
      }}
      containerClassName="nearest-city-pod-container"
    />
  ) : null;
};

NearestCity.propTypes = {
  nearestCity: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(NearestCity);
